import { Theme } from '@apia/theme';
import { layout } from './layout';
import stylesObject from './layout/stylesObject';
// import './fonts.css';
/* IMPORT HERE */

const customTheme: Omit<Theme, 'palette'> = {
  layout: layout as any,
  styles: {
    root: {
      ...stylesObject(),
    },
  },
  /* PREPEND HERE */
};

export default customTheme;
